import { render, staticRenderFns } from "./collectionOrderSet.vue?vue&type=template&id=3994a74e&"
import script from "./collectionOrderSet.vue?vue&type=script&lang=js&"
export * from "./collectionOrderSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collectionOrderSet.vue"
export default component.exports